import { Button } from '../../../../../../components'
import { IconPaths } from '../../../../../../../_metronic/helpers'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { useAbrirFormNotaVersao } from '../../../notas-versao-create/useAbrirFormNotaVersao'

export const NotasVersaoListToolbar = () => {
  const { t } = useT()
  const abrirForm = useAbrirFormNotaVersao()

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={() => abrirForm()}>
      {t('notas_versao.acao.nova')}
    </Button>
  )
}
